// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#windowContainer {
    font-size: 1rem!important;
}

.line-break {
    white-space: pre-wrap;
}

.line-break li {
    white-space: normal;
}

.language-mail_body {
    white-space: pre-line;
    font-size: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/main/frontend/pages/chatbox/components/chatBoxWindow.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,eAAe;AACnB","sourcesContent":["#windowContainer {\n    font-size: 1rem!important;\n}\n\n.line-break {\n    white-space: pre-wrap;\n}\n\n.line-break li {\n    white-space: normal;\n}\n\n.language-mail_body {\n    white-space: pre-line;\n    font-size: 1rem;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
